import "./../../utils/Style/component/login.scss";
import React, { useState, useEffect, useRef } from "react";
import {useNavigate, useParams} from "react-router-dom";
import { Text, Box, Image, Flex, Center, useToast } from "@chakra-ui/react";
import useLoginAPI from "../../api/loginAPI";
import { checkQrStatusTimer, qrTimeoutMinutes } from "../../utils/Constants";
import useValidateToken from "../../authentication/ValidateToken";

function Barcode() {
  const { isLoading, PortalOnBoard, CheckQrStatus } = useLoginAPI();
  const [qrUrl, setQrUrl] = useState("");
  const [qrTimeOut, setQrTimeOut] = useState(false);
  const _isMounted = useRef(false);
  const toast = useToast();
  const toastRef = useRef(null);
  var timerStatus;
  const { checkTokenExpiry } = useValidateToken();
  const navigate = useNavigate();

  function hasJWT() {
    //check user has JWT token
    return sessionStorage.getItem("Token") ? true : false;
  }

  const getCode = () => {
    const urlParams = new URLSearchParams(window.location.search);
    if(!urlParams.has('code')) return "";
    return urlParams.get('code');
  }

  useEffect(() => {
    if(getCode()){
      sessionStorage.setItem("RegCodUrl", getCode());
    }
  } , []);

  const onKeyDown = (e) => {
    if (qrTimeOut && (e.keyCode === 13 || e.keyCode === 32)) {
      PortalOnBoard(setQrTimeOut, setQrUrl, getCode());
    }
  }


  const checkToken = async () => await checkTokenExpiry();



  useEffect(() => {
    if (hasJWT()) {
      checkToken().then(() => {
        navigate("/Overview");
      }).catch(e => {
        PortalOnBoard(setQrTimeOut, setQrUrl, getCode());
      });
    } else {
      PortalOnBoard(setQrTimeOut, setQrUrl, getCode());
    }
  }, []);


  useEffect(() => {
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown)
    }
  }, [qrTimeOut])

  useEffect(() => {
    if (!_isMounted.current) {
      _isMounted.current = true;
      return;
    }
    var countDownDate = new Date();
    countDownDate.setMinutes(countDownDate.getMinutes() + qrTimeoutMinutes);
    countDownDate = countDownDate.getTime();

    timerStatus = setInterval(() => {
      var now = new Date().getTime();
      var distance = countDownDate - now;

      if (distance < 0) {
        clearInterval(timerStatus);
        setQrTimeOut(true);
        return;
      }

      if (
          sessionStorage.getItem("SessionID") &&
          sessionStorage.getItem("SessionID").length > 0 &&
        qrUrl.length > 0
      ) {
        CheckQrStatus(timerStatus, setQrTimeOut).catch((e) => {
          clearInterval(timerStatus);
          setQrTimeOut(true);
          toastRef.current = toast({
            position: "top",
            title: "Error",
            description: `An unexpected error has occured while logging you in. Please reload a QR code and try again.`,
            status: "error",
            duration: "5000",
            isClosable: "false",
          });
        });
      }
    }, checkQrStatusTimer);

    return () => {
      // 👇️ clear timeout when component unmounts
      clearInterval(timerStatus);
    };
  }, [qrUrl]);

  return (
    <div className="login">
      <div className="left">
        <div className="sub_container">
          <img className="suyool_img" src='/Images/suyool-white.png' />
          <div className="title">Corporate Portal</div>
          <div className="desc">Suyool Corporate Portal is a web-based platform designed to provide employees, customers, partners, and other stakeholders with secure, centralized access to a range of company-specific resources and information.</div>
          <div className="contact">
            <div className="txt"><b>Phone:</b> +961 81 222 015</div>
            <div className="txt"><b>Email:</b> contact@suyool.com</div>
          </div>
        </div>
      </div>

      <div className=" right">
        <img className="suyool_img" src='/Images/suyool-with-logo.png' />
        <div className="login_account">Login into Your Account</div>
        <div className="bar_code">
          <Flex align='center' justify='center'>
            {isLoading ? (
              <Center border='solid 1px #f1f1f1' w='232px' h='232px'>
                <Image w='40px' h='40px' src='/Images/skash_Rocket.gif' alt='Loading...' />
              </Center>
            ) : (
              <Center flexDir='column'>
                <Box>
                  <Text
                    textAlign='center'
                    fontSize={{ base: "15px", lg: "10px", xl: "15px" }}
                    fontWeight='bold'>
                    Scan QR code
                  </Text>
                </Box>
                <Flex
                  backgroundImage={qrUrl}
                  backgroundSize={{ base: "232px 232px", lg: "150px 150px", xl: "180px 180px", "2xl": "232px 232px", }}
                  width={{ base: "232px", lg: "150px", xl: "180px", "2xl": "232px", }}
                  height={{ base: "232px", lg: "150px", xl: "180px", "2xl": "232px", }}
                  align='center'
                  justify='center'>
                  {/*Reload a QR code Button*/}
                  {qrTimeOut && (
                    <Box
                      className='red-circle'
                      borderRadius='50%'
                      width={{ base: "200px", lg: "120px", xl: "150px", "2xl": "200px", }}
                      height={{ base: "200px", lg: "120px", xl: "150px", "2xl": "200px", }}
                      bgColor='#3682AC'
                      onKeyDown={onKeyDown}
                      onClick={() => PortalOnBoard(setQrTimeOut, setQrUrl, getCode())}>
                      <Flex
                        direction='column'
                        alignItems='center'
                        justifyContent='center'
                        w='100%'
                        h='100%'
                        padding={{ base: "25% 30px", lg: "0", xl: "25% 30px" }}>
                        <Image
                          src='/Images/skash_loading.png'
                          alt='loading'
                          w={{ base: "33px", lg: "18px", xl: "23px", "2xl": "33px", }}
                          h={{ base: "30px", lg: "18px", xl: "20px", "2xl": "30px", }}
                        />
                        <Text
                          fontSize={{ base: "15px", lg: "8px", xl: "10px", "2xl": "15px", }}
                          textAlign='center' padding='18px' color='#fff'>
                          CLICK TO RELOAD QR CODE
                        </Text>
                      </Flex>
                    </Box>
                  )}
                </Flex>
              </Center>
            )}
          </Flex>
        </div>
        <div className="copyrights">2023 Copyrights © Suyool</div>
      </div>
    </div>
  );
}

export default Barcode;
